<template>
  <div class="no-login">
    <div class="no-login-header">
      <span>登录之后可以</span>
    </div>
    <div
      v-report="{
        id: 'button',
        params: {
          type: 'login',
          ...publicReport,
        },
      }"
      class="content"
      @click="handleLogin"
    >
      <div
        class="no-login-content"
      >
        <div
          v-for="item in contentList"
          :key="item.title"
          class="no-login-content-item"
        >
          <img
            :src="item.icon"
            alt="icon"
          >
          <span>{{ item.title }}</span>
        </div>
      </div>
      <div
        class="no-login-btn"
      >
        <span>立即登录</span>
      </div>
    </div>

    <div
      v-report="{
        id: 'button',
        params: {
          type: 'feedback',
          ...publicReport,
        },
      }"
      class="no-login-feedback"
    >
      <div
        class="feedback-item"
        @click.stop="handleFeedback"
      >
        <ImageView
          class="feedback-icon"
          :src="Feedback"
          :style="{
            'tint-color': '#ffffff',
            '--tint-color': '#ffffff',
          }"
        />
        <span>问题反馈</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { openLogin } from '@common/logic';

import ImageView from '@/components/image-view.vue';
import Cloud from '@/assets/svg/no-login-cloud.svg';
import Fire from '@/assets/svg/no-login-fire.svg';
import Game from '@/assets/svg/no-login-game.svg';
import Message from '@/assets/svg/no-login-message.svg';
import Vip from '@/assets/svg/no-login-vip.svg';
import Feedback from '@/assets/img/feedback.png';
import { useLoginStore } from '@/store';
import { storeToRefs } from 'pinia';
import { addWebIssueFeedback } from '@/common/utils';

const loginStore = useLoginStore();
const { publicReport } = storeToRefs(loginStore);

const handleLogin = () => {
  console.info('[nav-login-panel] handleLogin');
  openLogin();
  loginStore.isFisrtLoading = true;
};

const contentList = [
  {
    icon: Cloud,
    title: '同步多端观看记录',
  },
  {
    icon: Message,
    title: '参与互动讨论',
  },
  {
    icon: Fire,
    title: '观看更多个性化内容',
  },
  {
    icon: Game,
    title: '领取专属游戏礼包',
  },
  {
    icon: Vip,
    title: '享受专属会员特惠',
  },
];
const FEEDBACK_ID = 1544;
const handleFeedback = () => {
  console.info('[nav-login-panel] handleFeedback');
  if (import.meta.env.EVO) {
    page?.userinfo?.openFeedbackWindow(FEEDBACK_ID);
  } else {
    addWebIssueFeedback();
  }
};
</script>

<style lang="scss" scoped>
.no-login {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 376px;
  border-radius: 16px;
  padding: 20px 16px;
  background-color: #1f1f1f;
  .no-login-header {
    flex-shrink: 0;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    height: 22px;
    margin-bottom: 24px;
  }
  .no-login-content {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    margin-bottom: 6px;
    width: 180px;
    cursor: pointer;

    .no-login-content-item {
      display: flex;
      margin-bottom: 18px;
      align-items: center;
      height: 24px;
      img {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }
      span {
        font-size: 16px;
        font-weight: 400;
        color: #999999;
      }
    }
  }
  .no-login-btn {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 44px;
    border-radius: 36px;
    background-color: #fff;
    margin-bottom: 12px;
    cursor: pointer;
    span {
      font-size: 16px;
      font-weight: 500;
      color: #000;
    }
  }
  .no-login-feedback {
    flex-shrink: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .feedback-item {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      height:18px;
      opacity: 0.6;
    }
    .feedback-item:hover {
      opacity: 1;
    }
    .feedback-icon {
      width: 12px;
      height: 12px;
      margin-right: 3px;
    }
    span {
      font-size: 13px;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  cursor: pointer;
}
</style>
